export default {
    _embeds: null,
    _url: null,
    init() {
        this._embeds = document.querySelectorAll('[data-embed]');
        if (!this._embeds) {
            return;
        }

        for (const embed of this._embeds) {
            const options    = JSON.parse(embed.getAttribute('data-embed'));
            const parsedUrl  = this._createEmbedLink(options);
            const embedClass = `embed__${parsedUrl ? 'video': 'other'}`;
            const src        = parsedUrl ? parsedUrl : options.url;
            embed.innerHTML = `<iframe class="${embedClass}" 
                                       src="${src}" 
                                       title="Embedded ${parsedUrl ? 'video': 'content'}"
                                       frameborder="0" allow="autoplay; 
                                                              fullscreen; 
                                                              accelerometer; 
                                                              encrypted-media; 
                                                              gyroscope; 
                                                              picture-in-picture" 
                                       allowfullscreen></iframe>`;
        }
    },
    _createEmbedLink(options) {
        const youtubeRegex = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*?[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig;
        const vimeoRegex = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
        const url = options.url;

        if (url.match(youtubeRegex)) {
            return url.replace(youtubeRegex, 'https://www.youtube.com/embed/$1') + 
                  (options.autoplay ? '?autoplay=1' : '');
        } else if (url.match(vimeoRegex)) {
            return url.replace(vimeoRegex, 'https://player.vimeo.com/video/$5') + 
                  (options.autoplay ? '?background=1&autoplay=1&loop=1&autopause=0&quality=720p' : '');
        }
    
        return false;
    }
}